import { Collapsible } from './../interfaces/collapsible.interface';
import { Entity } from './entity';
import { TbaEvaluationMethod } from './tba-evaluation-method';
import { Transaction } from './transaction';
import { TransactionType } from './transaction-type';
import { Study } from './study';
import { Container } from './container';
import { ControlledParameter } from './controlled-parameter';

export class Tba implements Collapsible {
  tbaId: number;
  name: string;
  description?: string;
  exclude = false;
  tbaEvaluationMethod = new TbaEvaluationMethod();
  transactionType = new TransactionType();
  primaryLegalEntity: Entity;
  study: Study;
  container: Container;
  collapsed: boolean;
  transactions: Transaction[]; // used for displaying controlled transactions in tba list
  tbaParameters: ControlledParameter[];
}
